import axios from "axios";
import Snippets from "./Snippets";

const baseURL = Snippets.urls.getAPIBaseURL();

//Create Axios Instance
const AxiosAPI = {
  getQueryVariable: (windowObj: any, key: any) => {
    //todo: doesn't belong

    if (typeof windowObj !== undefined) {
      var query = windowObj.location.search.substring(1);
      var vars = query.split("&");
      //console.log(2222, vars); //[ 'app=article', 'act=news_content', 'aid=160990' ]
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        //console.log(pair); //[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ]
        if (pair[0] == key) {
          return pair[1];
        }
      }
    }
    return "";
  },
  getTenantList: () => {
    var config = {
      method: "get",
      url: baseURL + "/super/tenants?page=0&pageSize=1000&profileType=BUYER",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },
  getProfileUsers: () => {
    var config = {
      method: "get",
      url: baseURL + "/profile/users",
      headers: {
        Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    return axios(config);
  },
  apiRequest: (method: string, url: string, data: any) => {
    var config = {
      method: method,
      url: baseURL + url,
      headers: {
        Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config);
  },
  publicApiRequest: (method: string, url: string, data: any) => {
    var config = {
      method: method,
      url: baseURL + url,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios(config);
  },
  getRewardsTransactions: (page:number=0, size:number=50) => {
    var config = {
      method: "get",
      url: baseURL + `/super/rewards/v1/transactions?page=${page}&size=${size}&sort=id,desc`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  deleteRewardsItem: (id: number) => {
    var config = {
      method: "delete",
      url: baseURL + `/super/reward-prizes/v1/${id}`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  delRewardsItem: (id: number) => {
    var config = {
      method: "delete",
      url: baseURL + `/super/reward-prizes/v1/${id}`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  getRewardsItem: (id: number) => {
    var config = {
      method: "get",
      url: baseURL + `/super/reward-prizes/v1/${id}`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  getRewardsItems: () => {
    var config = {
      method: "get",
      url: baseURL + `/super/reward-prizes/v1`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  setRewardsItems: (name: string, points: number, price: number, s3Key: string, id: number) => {
    var config = {
      method: "post",
      url: baseURL + `/super/reward-prizes/v1/`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        id: id,
        name: name,
        points: points,
        price: price,
        s3Key: s3Key
      }
    };
    return axios(config);
  },
  getRewardsTenantGroups: () => {
    var config = {
      method: "get",
      url: baseURL + `/super/tenant-groups/v1`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  setRewardsTenantGroups: (name:string, id:number) => {
    var config = {
      method: "post",
      url: baseURL + `/super/tenant-groups/v1`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        id: id,
        name: name
      }
    };
    return axios(config);
  },
  addRewardsGroupTenant: (groupId:number, profileId:number) => {
    var config = {
      method: "post",
      url: baseURL + `/super/tenant-groups/v1/add-tenant`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        profileId: profileId,
        groupId: groupId
      }
    };
    return axios(config);
  },
  getRewardsGroupPoints: (groupId:number, eventTypeId:number) => {
    var config = {
      method: "get",
      url: baseURL + `/super/rewards/v1/group-points/?groupId=${groupId}&eventTypeId=${eventTypeId}`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  setRewardsGroupPoints: (
    tenantGroupId:number,
    tenantGroupName: string,
    rewardEventTypeId: number,
    rewardEventTypeSlug:string,
    rewardEventTypeName:string,
    rewardEventTypeDescription:string,
    rewardEventTypePoints: string,
    rewardEventTypeEnabled: boolean,
    rewardGroupPointId: number = 0
  ) => {
    var config = {
      method: "post",
      url: baseURL + `/super/rewards/v1/group-points`,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        id: rewardGroupPointId,
        tenantGroup: {
          id: tenantGroupId,
          name: tenantGroupName
        },
        rewardEventType: {
          id: rewardEventTypeId,
          slug: rewardEventTypeSlug,
          name: rewardEventTypeName,
          description: rewardEventTypeDescription,
          points: rewardEventTypePoints,
          enabled: rewardEventTypeEnabled
        },
        points: rewardEventTypePoints
      }
    };
    return axios(config);
  },
  getRewardsSummary: () => {
    var config = {
      method: "get",
      url: baseURL + "/super/rewards/v1/summary",
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  getRewardsLevels: () => {
    var config = {
      method: "get",
      url: baseURL + "/super/rewards/v1/levels",
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  setRewardsLevel: (name: string, points:number, id: number=0) => {
    var config = {
      method: "post",
      url: baseURL + "/super/rewards/v1/levels",
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: {
        id: id,
        name: name,
        points: points
      }
    };
    return axios(config);
  },
  deleteRewardsLevel: (id:number) => {
    var config = {
      method: "delete",
      url: baseURL + "/super/rewards/v1/levels/"+id,
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  getRewardsEventTypes: () => {
    var config = {
      method: "get",
      url: baseURL + "/super/rewards/v1/event-types",
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    return axios(config);
  },
  setRewardsEventType: (id:number, data: any) => {
    var config = {
      method: "put",
      url: baseURL + "/super/rewards/v1/"+id+"/event-types",
      headers: {
        //Authorization: "Bearer " + Snippets.user.getCurrentUserAccessToken(),
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data
    };
    return axios(config);
  },
};
export default AxiosAPI;

export { AxiosAPI }
